import React from "react";
import { Loader2 } from "lucide-react";

/**
 * Reusable inline loading indicator.
 * @param {"sm"|"md"|"lg"} size - Controls spinner dimensions
 * @param {string} text - Optional loading text to display
 * @param {string} className - Additional CSS classes for the wrapper
 */
export default function InlineLoader({ size = "md", text, className = "" }) {
    const sizeMap = { sm: 16, md: 24, lg: 32 };
    const iconSize = sizeMap[size] || sizeMap.md;

    return (
        <div
            className={`flex items-center justify-center gap-2 text-gray-500 py-4 ${className}`}
        >
            <Loader2 className="animate-spin text-green-600" size={iconSize} />
            {text && <span className="text-sm">{text}</span>}
        </div>
    );
}

/**
 * Full-area loader for pages — vertically and horizontally centered.
 */
export function PageLoader({ text = "Loading..." }) {
    return (
        <div className="flex flex-col items-center justify-center min-h-[60vh] gap-3">
            <Loader2 className="animate-spin text-green-600" size={36} />
            <span className="text-sm text-gray-500">{text}</span>
        </div>
    );
}
